
module.exports = require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** (webpack)-dev-server/~/socket.io-client/index.js
 ** module id = 199
 ** module chunks = 0
 **/